import RepresentativeService from '_services/rest/modules/representative';

export default {
  state: {
    representative: null,
    representativeList: null,
    deattachedResellers: null,
    attachedResellers: null,
  },
  mutations: {
    setRepresentativeList(state, response) {
      state.representativeList = response;
    },
    setRepresentative(state, response) {
      state.representative = response;
    },
    setAttachedResellers(state, response) {
      state.attachedResellers = response;
    },
    setDeattachedResellers(state, response) {
      state.deattachedResellers = response;
    },
  },
  actions: {
    getRepresentativeList({ commit }, params) {
      return RepresentativeService.getList(params)
        .then(response => {
          commit('setRepresentativeList', response);
        });
    },
    getRepresentative({ commit }, params) {
      return RepresentativeService.getRepresentativeById(params)
        .then(representative => {
          commit('setRepresentative', representative);
        })
        .catch(error => {
          throw error.message;
        });
    },
    getAttachedResellers({ commit }, params) {
      return RepresentativeService.getAttachedResellers(params)
        .then(response => {
          if (params.group && params.group === 'attached') {
            commit('setAttachedResellers', response);
            return response;
          }
          commit('setDeattachedResellers', response);
          return response;
        });
    },
    setAttachedResellers({ commit }, params) {
      commit('setAttachedResellers', params);
    },
    syncAttacherResellers({ commit }, { attachedResellers, representativeId }) {
      commit('setAttachedResellers', attachedResellers);
      return RepresentativeService.syncResellers(attachedResellers, representativeId);
    },
  },
};
